import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "";

export const getServerIp = () => axios.get(`${API_BASE}/api/server-ip`).then((r) => r.data);

export const getPoStatus = () => axios.get(`${API_BASE}/api/po/status`).then((r) => r.data);

export const uploadReorder = (file, requestDate) => {
  const form = new FormData();
  form.append("file", file);
  form.append("request_date", requestDate);
  return axios.post(`${API_BASE}/api/reorder/upload`, form, bothHeaders()).then((r) => r.data);
};

export const listUploads = () => axios.get(`${API_BASE}/api/reorder/uploads`).then((r) => r.data);

export const getMapping = (sessionId) =>
  axios.get(`${API_BASE}/api/reorder/${sessionId}/mapping`).then((r) => r.data);

export const deleteSession = (sessionId, pin) =>
  axios.delete(`${API_BASE}/api/reorder/${sessionId}`, { data: { pin }, ...bothHeaders() }).then((r) => r.data);

export const archiveSession = (sessionId) =>
  axios.patch(`${API_BASE}/api/reorder/${sessionId}/archive`, {}, bothHeaders()).then((r) => r.data);

export const toggleConfirmation = (sessionId) =>
  axios.patch(`${API_BASE}/api/reorder/${sessionId}/toggle-confirmation`, {}, bothHeaders()).then((r) => r.data);

export const getOverall = () =>
  axios.get(`${API_BASE}/api/dashboard/overall`).then((r) => r.data);

export const refreshPoCache = () =>
  axios.post(`${API_BASE}/api/po/refresh`, {}, bothHeaders()).then((r) => r.data);

export const getConsolidated = () =>
  axios.get(`${API_BASE}/api/consolidated`).then((r) => r.data);

export const getExpiredPos = (limit = 100, offset = 0, minValidityDays = 14) =>
  axios.get(`${API_BASE}/api/expired-pos`, { params: { limit, offset, min_validity_days: minValidityDays } }).then(r => r.data);

export const getConsolidatedPage = (limit = 100, offset = 0) =>
  axios.get(`${API_BASE}/api/consolidated`, { params: { limit, offset } }).then(r => r.data);

export const getAllSessionsFlat = () =>
  axios.get(`${API_BASE}/api/all-sessions-flat`).then(r => r.data);

export const styleLookup = (style) =>
  axios.get(`${API_BASE}/api/style-lookup`, { params: { style } }).then(r => r.data);

export const getVendorScore = () => axios.get(`${API_BASE}/api/vendor-score`).then(r => r.data);

// Vendor Master
export const listVendors = () => axios.get(`${API_BASE}/api/vendors`).then(r => r.data);
export const createVendor = (data) => axios.post(`${API_BASE}/api/vendors`, data, bothHeaders()).then(r => r.data);
export const updateVendor = (id, data) => axios.put(`${API_BASE}/api/vendors/${id}`, data, bothHeaders()).then(r => r.data);
export const deleteVendor = (id) => axios.delete(`${API_BASE}/api/vendors/${id}`, bothHeaders()).then(r => r.data);
export const regenerateToken = (id) => axios.post(`${API_BASE}/api/vendors/${id}/regenerate-token`, {}, bothHeaders()).then(r => r.data);
export const sendVendorEmail = (id, portalBase) =>
  axios.post(`${API_BASE}/api/vendors/${id}/send-email`, { portal_base: portalBase }, bothHeaders()).then(r => r.data);

export const sendBulkVendorEmails = (suppliers, onlyPending = false) =>
  axios.post(`${API_BASE}/api/vendors/send-email-bulk`, { suppliers, only_pending: onlyPending }, bothHeaders()).then(r => r.data);

// Vendor Portal (public)
export const getVendorPortal = (token) => axios.get(`${API_BASE}/api/vendor-portal/${token}`).then(r => r.data);
export const submitVendorResponses = (token, responses) =>
  axios.post(`${API_BASE}/api/vendor-portal/${token}/respond`, { responses }).then(r => r.data);

// Vendor Responses (admin)
export const getVendorResponses = () => axios.get(`${API_BASE}/api/vendor-responses`).then(r => r.data);
export const updateVendorResponse = (id, data) =>
  axios.put(`${API_BASE}/api/vendor-responses/${id}`, data).then(r => r.data);
export const deleteVendorResponse = (id, pin) =>
  axios.delete(`${API_BASE}/api/vendor-responses/${id}`, { params: { pin }, ...bothHeaders() }).then(r => r.data);
export const bulkSetVendorResponseHold = (ids, onHold) =>
  axios.post(`${API_BASE}/api/vendor-responses/bulk-set-hold`, { ids, on_hold: onHold }, {
    headers: { "X-Admin-Token": (typeof localStorage !== "undefined" ? localStorage.getItem("reorder_admin_token") : "") || "" },
  }).then(r => r.data);
export const bulkMarkVendorResponsesItReady = (ids) =>
  axios.post(`${API_BASE}/api/vendor-responses/bulk-mark-it-ready`, { ids }, {
    headers: { "X-Admin-Token": (typeof localStorage !== "undefined" ? localStorage.getItem("reorder_admin_token") : "") || "" },
  }).then(r => r.data);
export const setVendorResponseHold = (id, onHold) =>
  axios.post(`${API_BASE}/api/vendor-responses/${id}/set-hold`, { on_hold: onHold }, {
    headers: { "X-Admin-Token": (typeof localStorage !== "undefined" ? localStorage.getItem("reorder_admin_token") : "") || "" },
  }).then(r => r.data);
export const markVendorResponseItReady = (id, pin) =>
  axios.post(`${API_BASE}/api/vendor-responses/${id}/mark-it-ready`, { pin }, {
    headers: { "X-Admin-Token": (typeof localStorage !== "undefined" ? localStorage.getItem("reorder_admin_token") : "") || "" },
  }).then(r => r.data);
export const cancelVendorResponse = (id, pin) =>
  axios.post(`${API_BASE}/api/vendor-responses/${id}/cancel`, { pin }, {
    headers: { "X-Admin-Token": (typeof localStorage !== "undefined" ? localStorage.getItem("reorder_admin_token") : "") || "" },
  }).then(r => r.data);

// 2026-10-12 remove-pin: PIN sign-in, Ecom / Shailendra team PIN pages, the admin-portal and approver logins and the PIN
// security settings are gone (server answers 410). The session cookie authenticates every call below.
// TODO(2026-10-12): the *Headers() helpers below still send the old X-Device-Token / X-Admin-Token / X-Approver-Token values from
// localStorage; those keys are cleared at sign-in, so the headers are empty and the server ignores them. Remove the helpers in a
// later clean-up (touches most api calls - kept out of this change to keep the diff reviewable).
// Auto-import
const bothHeaders = () => ({
  headers: {
    "X-Device-Token":   localStorage.getItem("reorder_device_token")   || "",
    "X-Admin-Token":    localStorage.getItem("reorder_admin_token")    || "",
    "X-Approver-Token": localStorage.getItem("reorder_approver_token") || "",
  }
});
export const autoImportStatus = () => axios.get(`${API_BASE}/api/auto-import/status`).then(r => r.data);
export const autoImportRun    = () => axios.post(`${API_BASE}/api/auto-import/run`, {}, bothHeaders()).then(r => r.data);

// Blockbuster Colour Master
export const getBlockbusterItems = (vendor = "") => axios.get(`${API_BASE}/api/blockbuster/items${vendor ? `?vendor=${encodeURIComponent(vendor)}` : ""}`, bothHeaders()).then(r => r.data);
export const reloadBlockbuster   = () => axios.post(`${API_BASE}/api/blockbuster/reload`, {}, { headers: { "X-Admin-Token": localStorage.getItem("reorder_admin_token") || "" } }).then(r => r.data);
export const decideBlockbuster   = (design_root, status, { colours = [], reason = "" } = {}) => axios.post(`${API_BASE}/api/blockbuster/decide`, { design_root, status, colours, reason }, bothHeaders()).then(r => r.data);
export const reopenBlockbuster   = (design_root) => axios.post(`${API_BASE}/api/blockbuster/reopen`, { design_root }, bothHeaders()).then(r => r.data);
export const emailBlockbusterBuyers = () => axios.post(`${API_BASE}/api/blockbuster/email-buyers`, {}, bothHeaders()).then(r => r.data);

// App-wide settings (public read, admin write)
export const getAppSettings = () =>
  axios.get(`${API_BASE}/api/app-settings`).then(r => r.data);
export const adminSaveAppSettings = (token, data) =>
  axios.put(`${API_BASE}/api/admin/app-settings`, data, { headers: { "X-Admin-Token": token } }).then(r => r.data);
export const adminGetAppSettingsLog = (token) =>
  axios.get(`${API_BASE}/api/admin/app-settings/log`, { headers: { "X-Admin-Token": token } }).then(r => r.data);

// Admin management
const adminHeaders = (token) => ({ headers: { "X-Admin-Token": token } });
export const adminGetNotifySettings = (token) =>
  axios.get(`${API_BASE}/api/admin/notify-settings`, adminHeaders(token)).then(r => r.data);
export const adminSaveNotifySettings = (token, data) =>
  axios.post(`${API_BASE}/api/admin/notify-settings`, data, adminHeaders(token)).then(r => r.data);

// Buyer rejections (session-scoped)
// Sends both device and admin tokens so both buyer and Admin sessions work.
const actionHeaders = () => {
  const headers = {};
  const deviceToken = localStorage.getItem("reorder_device_token") || "";
  const adminToken  = localStorage.getItem("reorder_admin_token")  || "";
  if (deviceToken) headers["X-Device-Token"] = deviceToken;
  if (adminToken)  headers["X-Admin-Token"]  = adminToken;
  return { headers };
};
export const getSessionRejections = (sessionId) =>
  axios.get(`${API_BASE}/api/reorder/${sessionId}/rejections`).then(r => r.data);
export const rejectItem = (sessionId, styleNumber, reason, note) =>
  axios.post(`${API_BASE}/api/reorder/${sessionId}/reject-item`, { style_number: styleNumber, reason, note }, actionHeaders()).then(r => r.data);
export const unRejectItem = (sessionId, styleNumber) =>
  axios.delete(`${API_BASE}/api/reorder/${sessionId}/reject-item`, { data: { style_number: styleNumber }, ...actionHeaders() }).then(r => r.data);
export const rejectItemsBulk = (sessionId, styleNumbers, reason, note) =>
  axios.post(`${API_BASE}/api/reorder/${sessionId}/reject-items-bulk`, { style_numbers: styleNumbers, reason, note }, actionHeaders()).then(r => r.data);

export const getGlobalRejections = () =>
  axios.get(`${API_BASE}/api/reorder/rejections-global`).then(r => r.data);
export const rejectItemGlobal = (styleNumber, reason, note) =>
  axios.post(`${API_BASE}/api/reorder/reject-item-global`, { style_number: styleNumber, reason, note }, actionHeaders()).then(r => r.data);
export const unRejectItemGlobal = (styleNumber) =>
  axios.delete(`${API_BASE}/api/reorder/reject-item-global`, { data: { style_number: styleNumber }, ...actionHeaders() }).then(r => r.data);

// Blacklist (permanent, global)
export const getBlacklist = () => axios.get(`${API_BASE}/api/blacklist`).then(r => r.data);
export const addToBlacklist = (styleNumber, reason, note, vendor) =>
  axios.post(`${API_BASE}/api/blacklist`, { style_number: styleNumber, reason, note, vendor }, actionHeaders()).then(r => r.data);
export const removeFromBlacklist = (styleNumber) =>
  axios.delete(`${API_BASE}/api/blacklist/${encodeURIComponent(styleNumber)}`, actionHeaders()).then(r => r.data);

// Buyer PO Reminders
// Passes both tokens — server validates and determines the caller's role automatically.
const reminderHeaders = () => {
  const headers = {};
  const deviceToken = localStorage.getItem("reorder_device_token") || "";
  const adminToken  = localStorage.getItem("reorder_admin_token")  || "";
  if (adminToken)  headers["X-Admin-Token"]  = adminToken;
  if (deviceToken) headers["X-Device-Token"] = deviceToken;
  return headers;
};

export const sendBuyerReminder = (buyer) =>
  axios.post(`${API_BASE}/api/reminders/send-buyer-reminder`, { buyer }, { headers: reminderHeaders() }).then(r => r.data);

export const getReminderCooldowns = () =>
  axios.get(`${API_BASE}/api/reminders/cooldown-status`, { headers: reminderHeaders() }).then(r => r.data);

export const listPendingUploads = () =>
  axios.get(`${API_BASE}/api/reorder/pending`).then(r => r.data);
export const approvePendingUpload = (id) =>
  axios.post(`${API_BASE}/api/reorder/pending/${id}/approve`, {}, bothHeaders()).then(r => r.data);
export const rejectPendingUpload = (id) =>
  axios.delete(`${API_BASE}/api/reorder/pending/${id}`, bothHeaders()).then(r => r.data);

// Style rates (buyer-editable last-in rate per style)
const storedAdminHeaders = () => ({ headers: { "X-Admin-Token": localStorage.getItem("reorder_admin_token") || "" } });
export const getStyleRates = () => axios.get(`${API_BASE}/api/style-rates`).then(r => r.data);
export const setStyleRate = (styleNumber, rate) =>
  axios.patch(`${API_BASE}/api/style-rates/${encodeURIComponent(styleNumber)}`, { rate }, storedAdminHeaders()).then(r => r.data);

// CP Value Approvals (line items over the CP-value threshold) — any logged-in
// buyer or admin can view/decide, so these send both tokens and let the server
// accept whichever is present.
// sessionId "latest" (default view, 2026-10-20) = each buyer's latest upload only; null = all sessions.
export const getCpApprovals = (status = "pending", sessionId = null) =>
  axios.get(`${API_BASE}/api/cp-approvals`, { params: { status, ...(sessionId === "latest" ? { latest: "1" } : { session_id: sessionId || undefined }) }, ...bothHeaders() }).then(r => r.data);
export const approveCpApproval = (id, rate) =>
  axios.post(`${API_BASE}/api/cp-approvals/${id}/approve`, { rate }, bothHeaders()).then(r => r.data);
export const rejectCpApproval = (id, note) =>
  axios.post(`${API_BASE}/api/cp-approvals/${id}/reject`, { note }, bothHeaders()).then(r => r.data);
export const bulkDecideCpApprovals = (ids, action, note, level, group, otb) =>
  axios.post(`${API_BASE}/api/cp-approvals/bulk-decide`, { ids, action, note, level, group, otb }, bothHeaders()).then(r => r.data);
export const getCpSessionTotals = (sessionIds) =>
  axios.get(`${API_BASE}/api/cp-approvals/session-totals`, { params: { session_ids: sessionIds.join(",") }, ...bothHeaders() }).then(r => r.data);
export const setCpApprovalRate = (id, rate) =>
  axios.patch(`${API_BASE}/api/cp-approvals/${id}/rate`, { rate }, bothHeaders()).then(r => r.data);
export const backfillCpApprovals = (since) =>
  axios.post(`${API_BASE}/api/cp-approvals/backfill`, { since }, bothHeaders()).then(r => r.data);
// 2026-10-20 Jev reorder confidence: stored scores for a session + score up to 10 styles (server skips unchanged ones).
export const getJevScores = (sessionId) =>
  axios.get(`${API_BASE}/api/jev/scores`, { ...bothHeaders(), params: { session_id: sessionId } }).then(r => r.data);
export const jevScore = (sessionId, items) =>
  axios.post(`${API_BASE}/api/jev/score`, { session_id: sessionId, items }, bothHeaders()).then(r => r.data);
// 2026-10-20 Stock Reco Blacklisted "Pull back now?": stored scores of a run date + score up to 10 styles.
export const getJevPullbackScores = (date) =>
  axios.get(`${API_BASE}/api/jev/pullback-scores`, { ...bothHeaders(), params: { date } }).then(r => r.data);
export const jevPullbackScore = (date, items) =>
  axios.post(`${API_BASE}/api/jev/pullback-score`, { date, items }, bothHeaders()).then(r => r.data);
export const syncCpRejections = () =>
  axios.post(`${API_BASE}/api/cp-approvals/sync-rejections`, {}, bothHeaders()).then(r => r.data);
export const refreshCpExclusiveStatus = () =>
  axios.post(`${API_BASE}/api/cp-approvals/refresh-exclusive-status`, {}, bothHeaders()).then(r => r.data);
// 2026-10-24: opts.group = styleNumber is a style identifier (all colour variants together, Ginesys only).
// 2026-10-17: opts.source "ginesys" (server default) | "planning"; opts.attribution "sale" (default) | "return" (Ginesys only).
export const getCpStyleWeeklyPerformance = (styleNumber, weeks = 12, size = null, opts = {}) =>
  axios.get(`${API_BASE}/api/cp-approvals/weekly-performance`, { params: { style: styleNumber, weeks, size: size || undefined, source: opts.source || undefined, attribution: opts.source === "planning" ? undefined : (opts.attribution || undefined), insight: opts.insight ? "1" : undefined, group: opts.group ? "1" : undefined }, ...bothHeaders() }).then(r => r.data);

// 2026-10-21 Closing stock setting (CP Approvals -> Configuration -> Closing stock; admin only).
export const getClosingStockConfig = () =>
  axios.get(`${API_BASE}/api/cp-approvals/closing-stock-config`, bothHeaders()).then(r => r.data);
export const getClosingStockSites = () =>
  axios.get(`${API_BASE}/api/cp-approvals/closing-stock-config/sites`, bothHeaders()).then(r => r.data);
export const getClosingStockLoccodes = (sites) =>
  axios.get(`${API_BASE}/api/cp-approvals/closing-stock-config/loccodes`, { params: { sites: sites.join(",") }, ...bothHeaders() }).then(r => r.data);
export const saveClosingStockConfig = (data) =>
  axios.put(`${API_BASE}/api/cp-approvals/closing-stock-config`, data, bothHeaders()).then(r => r.data);

// 2026-10-19: up to 20 styles' Ginesys 12-week results in one call (server keeps each for 2 days). weeks: 12 (default) or 26 (Stock Reco Blacklisted, 2026-10-27).
export const getCpWeeklyBatch = (styles, attribution = "sale", weeks) =>
  axios.post(`${API_BASE}/api/cp-approvals/weekly-performance/batch`, weeks ? { styles, attribution, weeks } : { styles, attribution }, bothHeaders()).then(r => r.data);

// Requested qty editing (Admin or Approver, per session/style/size), with a change log
// shared between the Mapping Table and the CP Value Approvals page.
export const setItemQty = (sessionId, styleNumber, size, qty, note) =>
  axios.patch(`${API_BASE}/api/reorder/${sessionId}/item-qty`, { style_number: styleNumber, size, qty, note }, bothHeaders()).then(r => r.data);
export const getQtyLog = (sessionId, styleNumber = null) =>
  axios.get(`${API_BASE}/api/reorder/${sessionId}/qty-log`, { params: { style_number: styleNumber || undefined } }).then(r => r.data);
export const getItemSizes = (sessionId, styleNumber) =>
  axios.get(`${API_BASE}/api/reorder/${sessionId}/item-sizes`, { params: { style_number: styleNumber } }).then(r => r.data);

// Item Master style search / detail + "Add Style" into a session (Admin only —
// server enforces via bothHeaders' admin token; used by MappingTable's + Add Style modal).
export const searchItemMasterStyles = (q, sessionId) =>
  axios.get(`${API_BASE}/api/item-master/style-search`, { params: { q, session_id: sessionId || undefined }, ...bothHeaders() }).then(r => r.data);
export const getItemMasterStyle = (styleNumber, sessionId) =>
  axios.get(`${API_BASE}/api/item-master/style/${encodeURIComponent(styleNumber)}`, { params: { session_id: sessionId || undefined }, ...bothHeaders() }).then(r => r.data);
export const addStyleToSession = (sessionId, styleNumber, sizes, note) =>
  axios.post(`${API_BASE}/api/reorder/${sessionId}/add-style`, { style_number: styleNumber, sizes, note }, bothHeaders()).then(r => r.data);

// API Export (IT integration)
export const getApiExportLog = () =>
  axios.get(`${API_BASE}/api/export/log`, storedAdminHeaders()).then(r => r.data);
export const downloadApiExportHit = (hitId) =>
  axios.get(`${API_BASE}/api/export/log/${hitId}/download`, { ...storedAdminHeaders(), responseType: "blob" });
export const getApiCredentials = () =>
  axios.get(`${API_BASE}/api/export/credentials`, storedAdminHeaders()).then(r => r.data);
export const saveApiCredentials = (username, password) =>
  axios.post(`${API_BASE}/api/export/credentials`, { username, password }, storedAdminHeaders()).then(r => r.data);

export const unsendApiExportHit = (hitId) =>
  axios.post(`${API_BASE}/api/export/log/${hitId}/unsend`, {}, storedAdminHeaders()).then(r => r.data);

// WhatsApp scheduled reports (admin only; server: "WHATSAPP SCHEDULED REPORTS" block in server.js)
export const getWaReports = () =>
  axios.get(`${API_BASE}/api/wa-reports`, storedAdminHeaders()).then(r => r.data);
export const createWaReport = (body) =>
  axios.post(`${API_BASE}/api/wa-reports`, body, storedAdminHeaders()).then(r => r.data);
export const updateWaReport = (id, body) =>
  axios.put(`${API_BASE}/api/wa-reports/${id}`, body, storedAdminHeaders()).then(r => r.data);
export const runWaReport = (id, mode) =>
  axios.post(`${API_BASE}/api/wa-reports/${id}/run`, { mode }, storedAdminHeaders()).then(r => r.data);
export const getWaReportRuns = (id, page, pageSize) =>
  axios.get(`${API_BASE}/api/wa-reports/${id}/runs`, { ...storedAdminHeaders(), params: { page, page_size: pageSize } }).then(r => r.data);
export const getWaReportAudit = (id, page, pageSize) =>
  axios.get(`${API_BASE}/api/wa-reports/${id}/audit`, { ...storedAdminHeaders(), params: { page, page_size: pageSize } }).then(r => r.data);
export const getWaTemplates = () =>
  axios.get(`${API_BASE}/api/wa-reports-templates`, storedAdminHeaders()).then(r => r.data);
export const createWaTemplate = (body) =>
  axios.post(`${API_BASE}/api/wa-reports-templates`, body, storedAdminHeaders()).then(r => r.data);
// WhatsApp "ask Ginesys" bot (admin only; server: backend/waBot.js)
export const getWaBotOverview = () =>
  axios.get(`${API_BASE}/api/wa-reports-bot/overview`, storedAdminHeaders()).then(r => r.data);
export const updateWaBotSettings = (body) =>
  axios.put(`${API_BASE}/api/wa-reports-bot/settings`, body, storedAdminHeaders()).then(r => r.data);
export const getWaBotMessages = (params) =>
  axios.get(`${API_BASE}/api/wa-reports-bot/messages`, { ...storedAdminHeaders(), params }).then(r => r.data);
export const getWaBotAudit = (page, pageSize) =>
  axios.get(`${API_BASE}/api/wa-reports-bot/audit`, { ...storedAdminHeaders(), params: { page, page_size: pageSize } }).then(r => r.data);

// Barcodes
export const getBarcodes =(params = {}) =>
  axios.get(`${API_BASE}/api/barcodes`, { ...storedAdminHeaders(), params }).then(r => r.data);
export const getAmbiguousBarcodes = () =>
  axios.get(`${API_BASE}/api/barcodes/ambiguous`, storedAdminHeaders()).then(r => r.data);
export const resolveBarcode = (style, size, barcode) =>
  axios.post(`${API_BASE}/api/barcodes/resolve`, { style, size, barcode }, storedAdminHeaders()).then(r => r.data);
export const fetchMissingBarcodes = () =>
  axios.post(`${API_BASE}/api/barcodes/fetch-missing`, {}, storedAdminHeaders()).then(r => r.data);
export const getPendingBarcodes = () =>
  axios.get(`${API_BASE}/api/barcodes/pending`, storedAdminHeaders()).then(r => r.data);

export const downloadMissingBarcodes = () =>
  axios.get(`${API_BASE}/api/barcodes/export-missing`, { ...storedAdminHeaders(), responseType: "blob" });

export const importBarcodes = (file) => {
  const form = new FormData();
  form.append("file", file);
  return axios.post(`${API_BASE}/api/barcodes/import`, form, storedAdminHeaders()).then(r => r.data);
};

// ── ARS / MBQ Management ───────────────────────────────────────────────────────
// Admin or Ecom only — server checks the same tokens as the rest of the app.
const arsHeaders = () => ({
  headers: {
    "X-Device-Token": localStorage.getItem("reorder_device_token") || "",
    "X-Admin-Token": localStorage.getItem("reorder_admin_token") || "",
  }
});

export const getArsMbq = (params = {}) =>
  axios.get(`${API_BASE}/api/ars/mbq`, { ...arsHeaders(), params }).then(r => r.data);
export const getArsStyleHistory = (style, size) =>
  axios.get(`${API_BASE}/api/ars/mbq/${encodeURIComponent(style)}/history`,
    { ...arsHeaders(), params: size ? { size } : {} }).then(r => r.data);
export const uploadArsMbqManual = (file) => {
  const form = new FormData();
  form.append("file", file);
  return axios.post(`${API_BASE}/api/ars/mbq/upload`, form, arsHeaders()).then(r => r.data);
};
export const uploadArsManualExclusions = (file) => {
  const form = new FormData();
  form.append("file", file);
  return axios.post(`${API_BASE}/api/ars/mbq/exclusions/upload`, form, arsHeaders()).then(r => r.data);
};
export const checkArsAssortmentFolder = () =>
  axios.post(`${API_BASE}/api/ars/mbq/check-folder`, {}, arsHeaders()).then(r => r.data);
export const generateArsMbqFile = () =>
  axios.post(`${API_BASE}/api/ars/mbq/generate`, {}, arsHeaders()).then(r => r.data);
export const generateArsMbqAuto = () =>
  axios.post(`${API_BASE}/api/ars/mbq/generate-auto`, {}, arsHeaders()).then(r => r.data);
export const downloadArsMbqFile = async (filename) => {
  const r = await axios.get(`${API_BASE}/api/ars/mbq/download`, {
    ...arsHeaders(), params: { file: filename }, responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([r.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
export const getArsUploads = () =>
  axios.get(`${API_BASE}/api/ars/uploads`, arsHeaders()).then(r => r.data);

// ── Vendor PDFs (buyer-wise, vendor-grouped reorder PDFs) ──────────────────────
export const getVendorPdfSummary = (sessionId) =>
  axios.get(`${API_BASE}/api/vendor-pdfs/summary`,
    { ...arsHeaders(), params: sessionId ? { session_id: sessionId } : {} }).then(r => r.data);

export const downloadVendorPdf = async (buyer, vendor, sessionId) => {
  const r = await axios.get(`${API_BASE}/api/vendor-pdfs/vendor-pdf`, {
    ...arsHeaders(), params: { buyer, vendor, ...(sessionId ? { session_id: sessionId } : {}) }, responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([r.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = `${vendor.replace(/[^a-zA-Z0-9]/g, "_")}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const downloadVendorPdfZip = async (buyer, sessionId, changedOnly = false) => {
  const r = await axios.get(`${API_BASE}/api/vendor-pdfs/buyer-zip`, {
    ...arsHeaders(), params: { buyer, ...(sessionId ? { session_id: sessionId } : {}), ...(changedOnly ? { changed: "1" } : {}) }, responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([r.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = `${buyer}_${changedOnly ? "updated_" : ""}${new Date().toISOString().slice(0, 10)}.zip`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const saveVendorPdfDraft = (buyer, sessionId, changedOnly = false) =>
  axios.post(`${API_BASE}/api/vendor-pdfs/save-draft`, { buyer, ...(sessionId ? { session_id: sessionId } : {}), ...(changedOnly ? { changed: true } : {}) }, arsHeaders()).then(r => r.data);

export const refreshArsBlacklist = () =>
  axios.post(`${API_BASE}/api/ars/blacklist/refresh`, {}, arsHeaders()).then(r => r.data);

export const uploadArsTransferinReport = (file) => {
  const form = new FormData();
  form.append("file", file);
  return axios.post(`${API_BASE}/api/ars/transferin/upload`, form, arsHeaders()).then(r => r.data);
};
// Kept for whenever IMAP gets verified against the real inbox — not called by the UI right now.
export const checkArsTransferinEmail = () =>
  axios.post(`${API_BASE}/api/ars/transferin/check-email`, {}, arsHeaders()).then(r => r.data);
export const getArsTransferinReports = () =>
  axios.get(`${API_BASE}/api/ars/transferin`, arsHeaders()).then(r => r.data);

export const getArsManualQueue = (all = false) =>
  axios.get(`${API_BASE}/api/ars/manual`, { ...arsHeaders(), params: { all } }).then(r => r.data);
export const uploadArsManualAllocations = (file) => {
  const form = new FormData();
  form.append("file", file);
  return axios.post(`${API_BASE}/api/ars/manual/upload`, form, arsHeaders()).then(r => r.data);
};
export const markArsManualUploaded = (id) =>
  axios.post(`${API_BASE}/api/ars/manual/${id}/mark-uploaded`, {}, arsHeaders()).then(r => r.data);
export const cancelArsManualAllocation = (id) =>
  axios.delete(`${API_BASE}/api/ars/manual/${id}`, arsHeaders()).then(r => r.data);

export const getArsPendingGeneration = (all = false) =>
  axios.get(`${API_BASE}/api/ars/pending-generation`, { ...arsHeaders(), params: { all } }).then(r => r.data);
export const addArsPendingGeneration = (styleNumber, note = "") =>
  axios.post(`${API_BASE}/api/ars/pending-generation`, { style_number: styleNumber, note }, arsHeaders()).then(r => r.data);
export const uploadArsPendingGeneration = (file) => {
  const form = new FormData();
  form.append("file", file);
  return axios.post(`${API_BASE}/api/ars/pending-generation/upload`, form, arsHeaders()).then(r => r.data);
};
export const removeArsPendingGeneration = (id) =>
  axios.delete(`${API_BASE}/api/ars/pending-generation/${id}`, arsHeaders()).then(r => r.data);
export const enrichArsPendingFromBuyfile = () =>
  axios.post(`${API_BASE}/api/ars/pending-generation/enrich`, {}, arsHeaders()).then(r => r.data);
export const setArsPendingProduct = (id, product) =>
  axios.patch(`${API_BASE}/api/ars/pending-generation/${id}/product`, { product }, arsHeaders()).then(r => r.data);

export const getArsStatus = () =>
  axios.get(`${API_BASE}/api/ars/status`, arsHeaders()).then(r => r.data);
export const getArsGenerateProgress = (job) =>
  axios.get(`${API_BASE}/api/ars/generate-progress`, { ...arsHeaders(), params: job ? { job } : {} }).then(r => r.data);

export const getArsMbqLastResult = () =>
  axios.get(`${API_BASE}/api/ars/mbq/last-result`, arsHeaders()).then(r => r.data);
export const getArsMbqDailySchedule = () =>
  axios.get(`${API_BASE}/api/ars/mbq/daily-schedule`, arsHeaders()).then(r => r.data);
export const setArsMbqDailySchedule = (enabled) =>
  axios.put(`${API_BASE}/api/ars/mbq/daily-schedule`, { enabled }, arsHeaders()).then(r => r.data);
// Allocation push switch (overall + per category) - GET/PUT /api/ars/allocation-push
export const getArsAllocationPush = () =>
  axios.get(`${API_BASE}/api/ars/allocation-push`, arsHeaders()).then(r => r.data);
export const setArsAllocationPush = (body) =>
  axios.put(`${API_BASE}/api/ars/allocation-push`, body, arsHeaders()).then(r => r.data);

// 1-pc Pullback (backend/onepc_pullback.py)
export const getOnepcStatus = () =>
  axios.get(`${API_BASE}/api/ars/onepc/status`, arsHeaders()).then(r => r.data);
export const saveOnepcConfig = (patch) =>
  axios.put(`${API_BASE}/api/ars/onepc/config`, patch, arsHeaders()).then(r => r.data);
export const runOnepcCycle = (dryRun) =>
  axios.post(`${API_BASE}/api/ars/onepc/run`, { dry_run: !!dryRun }, arsHeaders()).then(r => r.data);
export const getOnepcRuns = () =>
  axios.get(`${API_BASE}/api/ars/onepc/runs`, arsHeaders()).then(r => r.data);
export const getOnepcRun = (id) =>
  axios.get(`${API_BASE}/api/ars/onepc/runs/${id}`, arsHeaders()).then(r => r.data);
export const getOnepcBlocks = (all) =>
  axios.get(`${API_BASE}/api/ars/onepc/blocks`, { ...arsHeaders(), params: all ? { all: true } : {} }).then(r => r.data);
export const releaseOnepcBlock = (style, note) =>
  axios.post(`${API_BASE}/api/ars/onepc/blocks/${encodeURIComponent(style)}/release`, { note }, arsHeaders()).then(r => r.data);
export const importOnepcTracker = (file) => {
  const form = new FormData();
  form.append("file", file);
  return axios.post(`${API_BASE}/api/ars/onepc/import-tracker`, form, arsHeaders()).then(r => r.data);
};

export const getArsSizeRatios = () =>
  axios.get(`${API_BASE}/api/ars/size-ratios`, arsHeaders()).then(r => r.data);
export const setArsSizeRatio = (product, ratios, maxQtyPerSize = {}) =>
  axios.put(`${API_BASE}/api/ars/size-ratios/${encodeURIComponent(product)}`, { ratios, max_qty_per_size: maxQtyPerSize }, arsHeaders()).then(r => r.data);
export const deleteArsSizeRatio = (product) =>
  axios.delete(`${API_BASE}/api/ars/size-ratios/${encodeURIComponent(product)}`, arsHeaders()).then(r => r.data);

// ── Regional WH Configuration ────────────────────────────────────────────────
export const getArsRegionalWhList = () =>
  axios.get(`${API_BASE}/api/ars/regional-wh`, arsHeaders()).then(r => r.data);
export const getArsRegionalWhSourceSites = (refresh = false) =>
  axios.get(`${API_BASE}/api/ars/regional-wh/source-sites`, { ...arsHeaders(), params: refresh ? { refresh: true } : {} }).then(r => r.data);
export const getArsRegionalWhReportDates = () =>
  axios.get(`${API_BASE}/api/ars/regional-wh/report-dates`, arsHeaders()).then(r => r.data);
export const getArsRegionalWhDepartments = () =>
  axios.get(`${API_BASE}/api/ars/regional-wh/departments`, arsHeaders()).then(r => r.data);
export const getArsRegionalWhPlanningSites = () =>
  axios.get(`${API_BASE}/api/ars/regional-wh/planning-sites`, arsHeaders()).then(r => r.data);
export const getArsRegionalWhPlanningLoccodes = (admsiteCodes) =>
  axios.get(`${API_BASE}/api/ars/regional-wh/planning-loccodes`, { ...arsHeaders(), params: { sites: (admsiteCodes || []).join(",") } }).then(r => r.data);
export const addArsRegionalWh = (payload) =>
  axios.post(`${API_BASE}/api/ars/regional-wh`, payload, arsHeaders()).then(r => r.data);
export const updateArsRegionalWh = (site, payload) =>
  axios.put(`${API_BASE}/api/ars/regional-wh/${encodeURIComponent(site)}`, payload, arsHeaders()).then(r => r.data);
export const deleteArsRegionalWh = (site) =>
  axios.delete(`${API_BASE}/api/ars/regional-wh/${encodeURIComponent(site)}`, arsHeaders()).then(r => r.data);
export const getArsRegionalWhGap = (site, { date, refresh } = {}) =>
  axios.get(`${API_BASE}/api/ars/regional-wh/${encodeURIComponent(site)}/gap`, { ...arsHeaders(), params: { ...(date ? { date } : {}), ...(refresh ? { refresh: true } : {}) } }).then(r => r.data);
export const getArsRegionalWhRequests = (site) =>
  axios.get(`${API_BASE}/api/ars/regional-wh/${encodeURIComponent(site)}/requests`, arsHeaders()).then(r => r.data);
export const getArsRegionalWhSuggestedNewAdds = (site, limit = 30) =>
  axios.get(`${API_BASE}/api/ars/regional-wh/${encodeURIComponent(site)}/suggested-new-adds`, { ...arsHeaders(), params: { limit } }).then(r => r.data);
export const autoFillArsRegionalWh = (site, { room, exclude }) =>
  axios.post(`${API_BASE}/api/ars/regional-wh/${encodeURIComponent(site)}/auto-fill`, { room, exclude }, arsHeaders()).then(r => r.data);
export const getArsRegionalWhChangeLog = (site) =>
  axios.get(`${API_BASE}/api/ars/regional-wh/${encodeURIComponent(site)}/change-log`, arsHeaders()).then(r => r.data);
export const sendArsRegionalWhRequest = (site, rows) =>
  axios.post(`${API_BASE}/api/ars/regional-wh/${encodeURIComponent(site)}/send-request`, { rows }, arsHeaders()).then(r => r.data);
export const resendArsRegionalWhRequest = (site, requestId) =>
  axios.post(`${API_BASE}/api/ars/regional-wh/${encodeURIComponent(site)}/requests/${requestId}/resend`, {}, arsHeaders()).then(r => r.data);
export const getArsRegionalWhDraft = (site) =>
  axios.get(`${API_BASE}/api/ars/regional-wh/${encodeURIComponent(site)}/draft`, arsHeaders()).then(r => r.data);
export const saveArsRegionalWhDraft = (site, rows) =>
  axios.post(`${API_BASE}/api/ars/regional-wh/${encodeURIComponent(site)}/draft`, { rows }, arsHeaders()).then(r => r.data);
// Daily "Expected ARS trigger" history (collection ars_trigger_daily), oldest first.
export const getArsTriggerHistory = (days = 30) =>
  axios.get(`${API_BASE}/api/ars/trigger-history`, { ...arsHeaders(), params: { days } }).then(r => r.data);

// ── Profit Measurer ──────────────────────────────────────────────────────────
// Same access model/headers as ARS above — reuses arsHeaders() (device token for
// buyer/ecom, admin token for Admin); the server enforces per-route (resolveActionCaller
// for reads/calc, validateAdminToken for settings writes + pending-change decisions).
// 2026-10-20 Style profit lookup: up to 5 matches, never -ST/-DMG/-SPF; the server also pre-loads their weekly trends.
export const searchStyleProfit = (q) =>
  axios.get(`${API_BASE}/api/style-profit-lookup`, { ...bothHeaders(), params: { q } }).then(r => r.data);
// 2026-10-24 Style profit look-up history (30 days). logStyleLookup = one Insight opened; mine = my last 5 styles.
export const logStyleLookup = (style, view = "style", extra = {}) =>
  axios.post(`${API_BASE}/api/style-profit-lookup/history`, { style, view, ...(extra || {}) }, bothHeaders()).then(r => r.data);
// 2026-10-26 Insight for a whole search selection (<= 500 styles): one summed 26-week result. Can take about a minute for 100+ uncached styles.
export const getStyleGroupInsight = (styles, label) =>
  axios.post(`${API_BASE}/api/style-profit-lookup/group-insight`, { styles, label }, { ...bothHeaders(), timeout: 10 * 60000 }).then(r => r.data);
export const getStyleLookupHistoryStyles = (id) =>
  axios.get(`${API_BASE}/api/style-profit-lookup/history/${encodeURIComponent(id)}/styles`, bothHeaders()).then(r => r.data);
export const getStyleLookupHistory = (params = {}) =>
  axios.get(`${API_BASE}/api/style-profit-lookup/history`, { ...bothHeaders(), params }).then(r => r.data);
// 2026-10-26 Style profit search (Department / Vendor / Concept filters from the daily Ginesys list). Multi values are joined with the 0x1F separator.
const SEP = String.fromCharCode(31);
const searchParams = (p = {}) => {
  const o = {};
  if (p.q) o.q = p.q;
  // 2026-11-04: technique was never sent (filter had no effect); slab = ASP slab
  for (const k of ["department", "vendor", "concept", "technique", "slab"]) if ((p[k] || []).length) o[k] = p[k].join(SEP);
  for (const k of ["sort", "dir", "page", "page_size"]) if (p[k] != null) o[k] = p[k];
  return o;
};
export const getStyleSearchOptions = (p) =>
  axios.get(`${API_BASE}/api/style-profit-lookup/options`, { ...bothHeaders(), params: searchParams(p) }).then(r => r.data);
export const runStyleSearch = (p) =>
  axios.get(`${API_BASE}/api/style-profit-lookup/search`, { ...bothHeaders(), params: searchParams(p) }).then(r => r.data);
export const refreshStyleAttrs = () =>
  axios.post(`${API_BASE}/api/style-profit-lookup/refresh-attrs`, {}, { ...bothHeaders(), timeout: 11 * 60000 }).then(r => r.data);
export const exportStyleSearch = (p) =>
  axios.get(`${API_BASE}/api/style-profit-lookup/export`, { ...bothHeaders(), params: searchParams(p), responseType: "blob", timeout: 5 * 60000 });
// 2026-10-20 RSP/CP trial: current refresh vs Ginesys INVITEM, side by side (admin).
export const getGinesysRspCpCompare = (params = {}) =>
  axios.get(`${API_BASE}/api/style-master/ginesys-compare`, { ...bothHeaders(), params }).then(r => r.data);
export const runGinesysRspCpCompare = (sessionId) =>
  axios.post(`${API_BASE}/api/style-master/ginesys-compare/run`, sessionId ? { session_id: sessionId } : {}, bothHeaders()).then(r => r.data);
// 2026-10-20: pick which stored MRP / CP a style uses (value null = default: lowest MRP / highest CP).
export const chooseStyleValue = (style, field, value) =>
  axios.post(`${API_BASE}/api/style-master/${encodeURIComponent(style)}/choose`, { field, value }, bothHeaders()).then(r => r.data);
export const getStyleMaster = (params = {}) =>
  axios.get(`${API_BASE}/api/style-master`, { ...arsHeaders(), params }).then(r => r.data);
export const refreshStyleMaster = () =>
  axios.post(`${API_BASE}/api/style-master/refresh`, {}, arsHeaders()).then(r => r.data);
export const getStyleMasterRefreshStatus = () =>
  axios.get(`${API_BASE}/api/style-master/refresh-status`, arsHeaders()).then(r => r.data);
export const getStyleMasterPendingChanges = (status = "pending") =>
  axios.get(`${API_BASE}/api/style-master/pending-changes`, { ...arsHeaders(), params: { status } }).then(r => r.data);
export const acceptStyleMasterPendingChange = (id) =>
  axios.post(`${API_BASE}/api/style-master/pending-changes/${id}/accept`, {}, arsHeaders()).then(r => r.data);
export const dismissStyleMasterPendingChange = (id) =>
  axios.post(`${API_BASE}/api/style-master/pending-changes/${id}/dismiss`, {}, arsHeaders()).then(r => r.data);

export const getProfitSettings = () =>
  axios.get(`${API_BASE}/api/profit-settings`, arsHeaders()).then(r => r.data);
export const saveProfitSettings = (settings) =>
  axios.put(`${API_BASE}/api/profit-settings`, { settings }, arsHeaders()).then(r => r.data);
export const getInsightCacheInfo = () =>
  axios.get(`${API_BASE}/api/insight-cache`, arsHeaders()).then(r => r.data);
export const clearInsightCache = () =>
  axios.post(`${API_BASE}/api/insight-cache/clear`, {}, arsHeaders()).then(r => r.data);
export const getProfitSettingsChangeLog = () =>
  axios.get(`${API_BASE}/api/profit-settings/change-log`, arsHeaders()).then(r => r.data);

// cached=true (CP Approvals): server uses its shared discount copy (<= 45 min old) instead of a live fetch every call.
export const calcProfit = (items, cached = false) =>
  axios.post(`${API_BASE}/api/profit/calc`, cached ? { items, cached: true } : { items }, arsHeaders()).then(r => r.data);
export const getProfitDiscountExport = () =>
  axios.get(`${API_BASE}/api/profit/discount-export`, arsHeaders()).then(r => r.data);

export const deleteArsRegionalWhDraft = (site) =>
  axios.delete(`${API_BASE}/api/ars/regional-wh/${encodeURIComponent(site)}/draft`, arsHeaders()).then(r => r.data);

// ── SPF (Sales Performance Feedback / marketplace claims) — Profit Measurer ───
// Same access model as the rest of Profit Measurer above (arsHeaders(), server
// enforces resolveActionCaller per-route).
export const fetchSpfLiveFeed = () =>
  axios.post(`${API_BASE}/api/spf/fetch-live-feed`, {}, arsHeaders()).then(r => r.data);
export const getSpfLiveFeedStatus = () =>
  axios.get(`${API_BASE}/api/spf/live-feed-status`, arsHeaders()).then(r => r.data);
export const uploadSpfClaims = (file) => {
  const form = new FormData();
  form.append("file", file);
  return axios.post(`${API_BASE}/api/spf/claims/upload`, form, arsHeaders()).then(r => r.data);
};
export const getSpfClaimsStatus = () =>
  axios.get(`${API_BASE}/api/spf/claims/status`, arsHeaders()).then(r => r.data);
export const getSpfSummary = (params = {}) =>
  axios.get(`${API_BASE}/api/spf/summary`, { ...arsHeaders(), params }).then(r => r.data);
export const getSpfHighConcern = (params = {}) =>
  axios.get(`${API_BASE}/api/spf/high-concern`, { ...arsHeaders(), params }).then(r => r.data);
// Batched per-style, per-channel SPF claims totals for the Styles table's
// ProfitTooltip — see server.js's GET /api/spf/for-styles comment.
export const getSpfForStyles = (styleNumbers) =>
  axios.get(`${API_BASE}/api/spf/for-styles`, { ...arsHeaders(), params: { styles: styleNumbers.join(",") } }).then(r => r.data);

// 2026-10-12 Reorder flow strip + buyer "Done reviewing" (FLOW_CONTRACT.md). session_id = a session id or "all".
// Sent with the caller's tokens so the server applies the same department scope as elsewhere.
export const getReorderFlow = (sessionId = "all") =>
  axios.get(`${API_BASE}/api/reorder/flow`, { params: { session_id: sessionId }, ...bothHeaders() }).then((r) => r.data);
export const markBuyerReviewed = (sessionId, buyer) =>
  axios.post(`${API_BASE}/api/reorder/${sessionId}/review-done`, { buyer }, actionHeaders()).then((r) => r.data);
export const unmarkBuyerReviewed = (sessionId, buyer) =>
  axios.delete(`${API_BASE}/api/reorder/${sessionId}/review-done`, { params: { buyer }, ...actionHeaders() }).then((r) => r.data);

// 2026-10-13 OTB by grade + Fit to OTB (docs/specs/otb-grade-fit.md). Body: { session_id, buyer, department?, unit: "cp"|"qty",
// amount, include?, exclude?, np_by_style? }; apply also takes the confirmed `ranked` list. The server re-ranks and re-checks.
export const previewOtbFit = (body) =>
  axios.post(`${API_BASE}/api/cp-approvals/otb-fit/preview`, body, bothHeaders()).then((r) => r.data);
export const applyOtbFit = (body) =>
  axios.post(`${API_BASE}/api/cp-approvals/otb-fit/apply`, body, bothHeaders()).then((r) => r.data);
